module.exports = __webpack_public_path__ + "img/coop_sidebar.385a7f26.svg";